import type { ReactNode } from 'react';

import type { Role } from '@/stores/session';
import { usePermission } from './usePermission';

interface CanProps {
  /** Role (or any-of list) allowed to see the children. */
  role: Role | Role[];
  children: ReactNode;
  /** Rendered when the active role does not match (default: nothing). */
  fallback?: ReactNode;
}

/**
 * Declarative role gate: `<Can role="admin">…</Can>` or
 * `<Can role={['admin', 'teacher']}>…</Can>`. Reads the active membership's
 * role via {@link usePermission}. UX gating only — the server still enforces.
 */
export function Can({ role, children, fallback = null }: CanProps) {
  const { hasRole } = usePermission();
  const roles = Array.isArray(role) ? role : [role];
  return hasRole(...roles) ? <>{children}</> : <>{fallback}</>;
}
